/** @jsxImportSource @emotion/react */
import { FC, PropsWithChildren } from 'react';

import * as styles from './PageActions.styles';

export const PageActions: FC<PropsWithChildren> = ({ children }) => (
  <section id="form-actions" css={styles.container}>
    {children}
  </section>
);
